import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface PhoneReturn {
  mode: ComputedRef<InputMode>
  setPhone: (event: ChangeEvent) => void
}

export const usePhone = (): PhoneReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() =>getMode(tutorApplicationStore.showErrors && !tutorApplicationStore.form.phoneNumber))

  const setPhone = (event: ChangeEvent) => {
    tutorApplicationStore.setField('phoneNumber', event.value)
  }

  return {
    mode,
    setPhone,
  }
}
